<template>
  <v-app>
    <the-drawer
      v-if="$auth.isAuthenticated && $auth.hasRole('admin')"
      v-model="drawerIsVisible">
    </the-drawer>

    <the-app-bar
      @toggle-drawer="drawerIsVisible = !drawerIsVisible"
    ></the-app-bar>

    <v-main style="background-color: #F5F5F5">
      <router-view></router-view>
    </v-main>

    <the-notification></the-notification>

    <the-footer></the-footer>
  </v-app>
</template>

<script>
import TheDrawer from './components/TheDrawer.vue';
import TheAppBar from './components/TheAppBar.vue';
import TheNotification from './components/TheNotification.vue';
import TheFooter from './components/TheFooter.vue';

export default {
  name: 'App',

  components: {
    TheDrawer,
    TheAppBar,
    TheNotification,
    TheFooter,
  },

  data: () => ({
    drawerIsVisible: null,
  }),
};
</script>
